import { render } from "./ImportTransactionsForm.vue?vue&type=template&id=d45fbfc4"
import script from "./ImportTransactionsForm.vue?vue&type=script&lang=js"
export * from "./ImportTransactionsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__